import { codificarTextoComAvancoEscPos, formatarBlocoTextoParaEscPos } from './EscPosText';

/**
 * Imprime a confirmação de conexão com o avanço compatível com as impressoras.
 */
export function gerarTesteImpressora(
    imprimir58mm: boolean = false,
    fonteGrande: boolean = false
): Uint8Array {
    const largura = imprimir58mm ? 32 : 38;
    const separador = '*'.repeat(largura);
    const texto = [
        separador,
        'Conexão realizada com sucesso!',
        separador,
        ''
    ].join('\n');

    return new Uint8Array([
        0x1B, 0x40,
        0x1D, 0x21, fonteGrande ? 0x01 : 0x00,
        ...codificarTextoComAvancoEscPos(formatarBlocoTextoParaEscPos(texto, largura)),
        0x1D, 0x21, 0x00,
        0x0A, 0x0A, 0x0A, 0x0A, 0x0A,
        0x1B, 0x69
    ]);
}
